import React from 'react'

const Cotb2018 = () => (
  <div>
    <h1>Code on the Beach 2018</h1>
    <div>
        <div><a href="https://docs.google.com/presentation/d/1dhbL29CHw__viP52UnmMXvMFWqZNpxa_FYyrmWmecWg/edit?usp=sharing">Google Slides</a></div>
        <div><a href="https://github.com/jdomizio/cotb2018">Code Examples</a></div>
        <div><a href="https://github.com/jdomizio/guess.domiz.io">guess.domiz.io SignalR app</a></div>
        <div><a href="http://guess.domiz.io">Link to guessing game (guess.domiz.io)</a></div>
    </div>
  </div>
)

export default Cotb2018



// WEBPACK FOOTER //
// ./src/pages/cotb2018.js